import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/WizardSimulationCampaign/LandingPageStep'

export const FETCH_LANDING_PAGES_ASYNC = createAsyncTypes('FETCH_LANDING_PAGES', typeKey)

export const CHANGE_CREATED_BY_FILTER = `${typeKey}/CHANGE_CREATED_BY_FILTER`
export const CHANGE_TYPE_FILTER = `${typeKey}/CHANGE_TYPE_FILTER`
export const CHANGE_SORT_BY = `${typeKey}/CHANGE_SORT_BY`
export const SET_IS_VISITED = `${typeKey}/SET_IS_VISITED`

export const LANDING_PAGE_TYPE_CAST_TABLE = {
  ALL: 0,
  FULL_TUTORIAL: 1,
  SHORT_GAME: 2,
}
export const LANDING_PAGE_TYPE_LABELS_CAST_TABLE = {
  ALL: 'All',
  FULL_TUTORIAL: 'Full Tutorial',
  SHORT_GAME: 'Short Game',
}

export const TYPE_LABELS = {
  [LANDING_PAGE_TYPE_CAST_TABLE.FULL_TUTORIAL]: LANDING_PAGE_TYPE_LABELS_CAST_TABLE.FULL_TUTORIAL,
  [LANDING_PAGE_TYPE_CAST_TABLE.SHORT_GAME]: LANDING_PAGE_TYPE_LABELS_CAST_TABLE.SHORT_GAME,
}

export const LANDING_PAGE_TYPES = [
  {
    label: LANDING_PAGE_TYPE_LABELS_CAST_TABLE.ALL,
    value: LANDING_PAGE_TYPE_CAST_TABLE.ALL,
  },
  {
    label: LANDING_PAGE_TYPE_LABELS_CAST_TABLE.FULL_TUTORIAL,
    value: LANDING_PAGE_TYPE_CAST_TABLE.FULL_TUTORIAL,
  },
  {
    label: LANDING_PAGE_TYPE_LABELS_CAST_TABLE.SHORT_GAME,
    value: LANDING_PAGE_TYPE_CAST_TABLE.SHORT_GAME,
  },
]

export const SORT_BY_OPTIONS = [
  { label: 'Most Updated', value: false },
  { label: 'Last Used', value: true },
]

export const LANDING_PAGE_SELECTED_MESSAGE = 'Landing page Selected'
